module.exports = __webpack_public_path__ + "static/media/covers1.375d658c.jpg";